/**
 * Golf-Centric categories mapped for backward compatibility with existing Firestore data.
 * Updated to reflect the ClubLoop marketplace taxonomy.
 */
export const legacyCategories = [
  // {
  //   id: 'men-golf',
  //   name: "Men's Golf",
  //   icon: 'golf-men', // Standardize icons in your CSS/Assets later
  //   subcategories: ['Iron Sets', 'Drivers', 'Putters', 'Full Sets', 'Bags'],
  //   order: 16,
  // },
  // {
  //   id: 'women-golf',
  //   name: "Women's Golf",
  //   icon: 'golf-women',
  //   subcategories: ['Iron Sets', 'Drivers', 'Full Sets', 'Ladies Bags', 'Wedges'],
  //   order: 17,
  // },
  {
    id: 'junior-golf',
    name: 'Junior Golf',
    icon: 'golf-junior',
    subcategories: ["Boys' Sets", "Girls' Sets"],
    order: 18,
  },
  // {
  //   id: 'golf-clubs',
  //   name: 'Individual Clubs',
  //   icon: 'golf-club',
  //   subcategories: ['Drivers', 'Fairway Woods', 'Hybrids', 'Iron Sets', 'Wedges', 'Putters'],
  //   order: 19,
  // },
  {
    id: 'golf-bags',
    name: 'Bags & Travel',
    icon: 'golf-bag',
    subcategories: ['Stand Bags', 'Cart Bags', 'Travel Covers', 'Sunday Bags'],
    order: 20,
  },
  {
    id: 'tech-accessories',
    name: 'Tech & Rangefinders',
    icon: 'electronics',
    subcategories: ['Rangefinders', 'GPS Watches', 'Launch Monitors', 'Swing Analyzers'],
    order: 21,
  },
  {
    id: 'footwear',
    name: 'Golf Footwear',
    icon: 'shoe',
    subcategories: ['Spiked Shoes', 'Spikeless Shoes', 'Mens', 'Womens'],
    order: 22,
  },
  {
    id: 'training-aids',
    name: 'Training & Practice',
    icon: 'training',
    subcategories: ['Hitting Nets', 'Putting Mats', 'Swing Trainers', 'Alignment Sticks'],
    order: 23,
  },
  {
    id: 'accessories',
    name: 'Accessories',
    icon: 'golf-ball',
    subcategories: [ 'Gloves', 'Tees', 'Headcovers', 'Towels'],
    order: 24,
  },
];

/**
 * Standardized ClubLoop Grade System for condition tracking.
 */
export const CONDITIONS = ['A+ (New/Mint)', 'A (Excellent)', 'B (Good)', 'C (Fair)'];
